import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  memoryLocalCache,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

import { isAdminAuthHost } from './adminHost';

/**
 * Keep the OAuth handler on the same site as the admin portal to avoid
 * third-party storage partitioning in iOS Safari and Android Chrome.
 */
export function resolveFirebaseAuthDomain(): string {
  if (typeof window === 'undefined') return 'ezorder-platform.firebaseapp.com';
  const host = window.location.hostname.toLowerCase();
  if (isAdminAuthHost(host)) return 'web2pos.com';
  return 'ezorder-platform.firebaseapp.com';
}

// Firebase 프로젝트 설정 정보
const firebaseConfig = {
  apiKey: "AIzaSyDoTjp1__dH9h5VhQaoxPCTEP_2Q7EI4d4",
  authDomain: resolveFirebaseAuthDomain(),
  projectId: "ezorder-platform",
  storageBucket: "ezorder-platform.firebasestorage.app",
  messagingSenderId: "717231696586",
  appId: "1:717231696586:web:f2bee9f2fef8309456a233"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

/** 손님 /order·/home: IndexedDB persistent 캐시 오픈 비용 제거 → 첫 로드 단축(메뉴는 HTTPS 부트스트랩 우선). */
function isCustomerOrderFirestorePath(): boolean {
  if (typeof window === 'undefined') return false;
  const p = window.location.pathname || '';
  return p.startsWith('/order/') || p.startsWith('/home/');
}

// Firebase 서비스들
export const auth = getAuth(app); // 인증 (로그인/회원가입)
export const db = initializeFirestore(app, {
  localCache: isCustomerOrderFirestorePath()
    ? memoryLocalCache()
    : persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  // Long polling only on customer /order — admin list queries stay on WebChannel (much faster).
  ...(isCustomerOrderFirestorePath() ? { experimentalForceLongPolling: true } : {}),
});
export const storage = getStorage(app); // 파일 저장소

export default app;



